import { PREFERRED_WORKSPACE_PRESENTATION } from './workspace-route-contract';

import type { WorkspacePresentation } from './workspace-route-contract';

/**
 * The presentation the current surface writes and displays. A normal browser gets the preferred
 * (canonical) form. The Electron shell recognises only `/v2` as a chrome surface, restores only
 * `/v2` sections and clears its chrome readiness on any other in-page URL
 * (`frontend/desktop/src/desktop-events.ts`, `window-state.ts`, `main.ts`), so the hosted renderer
 * stays on the compatibility form there, writers included, until a shell with dual-family
 * predicates ships.
 *
 * The desktop marker is read directly rather than through `lib/desktop/bridge`, which imports the
 * notification translator and would close an import cycle through the route builders. Module-level
 * route tables call this at import time; the preload script exposes the marker before any renderer
 * script runs, so that read is already settled.
 */
export function surfaceWorkspacePresentation(): WorkspacePresentation {
  return globalThis.window?.publicPulseDesktop?.isDesktop === true
    ? 'compatibility'
    : PREFERRED_WORKSPACE_PRESENTATION;
}
